$(function(){
    var current = location.pathname;
    $('.site-nav li ul li a').each(function(){
        var $this = $(this);
         //if the current path is like this link, make it active
      	//alert($this.attr('href').indexOf(current));
        if($this.attr('href').indexOf(current) !== -1){
            $this.addClass('active');
        }
    });
  	if(window.location.pathname == '/'){
       $('ul.site-nav').find('.active').removeClass('active');
      $('.site-nav li.left-side-menu ul').find('a:first').addClass('active');
    }
})



